import { LocationFilter } from '../../search/locationFilter';

export const locationRadiusPath = (location: LocationFilter): string => {
    if ('known_location' in location) {
        return `in-${encodeURIComponent(location.known_location)}`;
    } else {
        return `near-${encodeURIComponent(location.query)}`;
    }
};

export default locationRadiusPath;
